import { http } from "../utils/http-common";
import { setErrorMessage } from "../utils/ToastMessageUtils";
import { Service } from "../interfaces/service.interface";
import { LocationQueryValue } from "vue-router";

export function isEmailAbailable(email: string) {
  return new Promise((resolve, reject) => {
    http
      .post(`/auth/isRegistered`, { email: email })
      .then((res) => {
        console.log("isEmailAvailable:", !res.data.isRegistered);
        resolve(!res.data.isRegistered);
      })
      .catch((e) => {
        const errorMessage = e.response ? e.response.data.message : e.message;
        setErrorMessage(errorMessage);
        reject(errorMessage);
      });
  });
}
export function createUserWithEmailPasswordAndCompany(email: string, password: string, companyName: string, services: Service[], workerEmails?: string[]) {
  return http
    .post(`/auth/register`, {
      email: email,
      password: password,
      companyName: companyName,
      companyServices: services,
      workerEmails: workerEmails,
    })
    .catch((e) => {
      setErrorMessage(e.response.data.message);
    });
}

export function requestOTP(email: string) {
  return http.get(`/auth/requestOTP?email=${encodeURIComponent(email)}`).then((res) => {
    return res.data;
  });
}

export function validateOTP(email: string, code: string) {
  return http
    .post(`/auth/validateOTP`, {
      email: email,
      code: code,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      const errorMessage = e.response ? e.response.data.message : e.message;
      setErrorMessage(errorMessage);
      throw e; // Re-throw to handle in component
    });
}

export async function loginUserWithEmailAndPassword(email: string, password: string) {
  return http
    .post(`/auth/login`, {
      email: email,
      password: password,
    })
    .then((res) => {
      return res.data;
    });
}

export function finishSignup(name: string, surnmame: string, password: string, uuid: LocationQueryValue | LocationQueryValue[]) {
  if (!uuid) {
    setErrorMessage("There was a problem with your registration. Please contact with the administrator.");
    return;
  }
  return new Promise((resolve, reject) => {
    return http
      .post(`/auth/finishSignup`, {
        uuid: uuid,
        name: name,
        surname: surnmame,
        password: password,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        const errorMessage = e.response && e.response.data ? e.response.data.message : e.message;
        setErrorMessage(errorMessage);
        reject(errorMessage);
      });
  });
}

export function resetPassword(password: string, uuid: string) {
  //console.log({ password, uuid });

  return new Promise((resolve, reject) => {
    return http
      .post(`/auth/resetPassword`, {
        password: password,
        uuid: uuid,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        const errorMessage = e.response && e.response.data ? e.response.data.message : e.message;
        setErrorMessage(errorMessage);
        reject(errorMessage);
      });
  });
}

export function sendResetLink(email: string) {
  return new Promise((resolve, reject) => {
    return http
      .post(`/auth/sendResetLink`, {
        email: email,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch(() => {
        reject();
      });
  });
}

export async function isValidToken(token: string) {
  const cachedToken = sessionStorage.getItem(`token_${token}`);
  if (cachedToken) {
    const { isValid, timestamp, isActive, emailVerified } = JSON.parse(cachedToken);
    const now = Date.now();
    const tenMinutes = 10 * 60 * 1000;
    if (now - timestamp < tenMinutes) {
      return { isValid, isActive, emailVerified };
    } else {
      sessionStorage.removeItem(`token_${token}`);
    }
  }
  return http
    .get(`/auth/isValidToken`, { params: { token: token } })
    .then((res) => {
      const { isValid, isActive, emailVerified } = res.data;
      if (isValid && isActive && emailVerified) {
        sessionStorage.setItem(`token_${token}`, JSON.stringify({ isValid, isActive, emailVerified, timestamp: Date.now() }));
      }
      return { isValid, isActive, emailVerified };
    })
    .catch((e) => {
      console.log(e);
      return { isValid: false, isActive: false, emailVerified: false };
    });
}

export async function validateToken(token: string) {
  if (!token) return false;
  return http.get(`/validateToken?token=${token}`).then((res) => res);
}
